export default {
    LOADING: 'c_loading',

    COORDINATES_LOADED: 'c_coordinates_loaded'
}


// WEBPACK FOOTER //
// ./App/components/modules/charts/action-types.js